module.exports = __webpack_public_path__ + "static/screenshot-1-4978bc42a365ed37165deb3da618e779.png";